import React from 'react';
import { useFormContext } from '../../../context/FormContext';
import { Input } from '../../ui/Input';

export const PurchaseMixSection = () => {
  const { data, updateFormSection } = useFormContext();
  const mix = data.form.purchaseMix;

  const updateField = (field, value) => {
    updateFormSection('purchaseMix', { ...mix, [field]: value });
  };

  const total = ['new', 'repeat', 'subscription', 'oneOff'].reduce((sum, key) => sum + (Number(mix[key]) || 0), 0);
  const isError = total > 0 && total !== 100;

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-4">
        <Input label="New Purchases (%)" type="number" value={mix.new} onChange={e => updateField('new', e.target.value)} />
        <Input label="Repeat Purchases (%)" type="number" value={mix.repeat} onChange={e => updateField('repeat', e.target.value)} />
        <Input label="Subscription / Recurring (%)" type="number" value={mix.subscription} onChange={e => updateField('subscription', e.target.value)} />
        <Input label="One-off Purchase (%)" type="number" value={mix.oneOff} onChange={e => updateField('oneOff', e.target.value)} />
      </div>
      
      <div className={`p-4 rounded-lg flex items-center justify-between font-medium text-sm ${isError ? 'bg-red-50 text-red-600 border border-red-200' : 'bg-brand-light/50 text-brand-text border border-brand-border'}`}>
        <span>Total Percentage</span>
        <span className="font-bold">{total}%</span>
      </div>
      {isError && <p className="text-xs text-red-500 mt-2">Percentages must equal exactly 100%.</p>}
    </div>
  );
};